module.exports = __webpack_public_path__ + "img/hint-black.dc19416c.svg";